import * as React from "react";
import styled from "styled-components";
import { spacing } from "../theme/spacing";
import { device } from "../theme/breakpoints";

const Prose = styled.div`
  @media only screen and ${device["$lg"]} {
    border-left: 1px solid;
    padding-left: ${spacing[4]};
    gap: 16px;
  }
`;

const ProjectProse = ({ children }) => {
  return <Prose>{children}</Prose>;
};

export default ProjectProse;
